module.exports = __webpack_public_path__ + "media/bootstrap-icons/book-half-e5aab309.svg";